import PropTypes from 'prop-types';

// material-ui
import { useTheme } from '@mui/material/styles';
import { Avatar, Box, ButtonBase, Divider, IconButton, Stack } from '@mui/material';
import MenuRoundedIcon from '@mui/icons-material/MenuRounded';

// project imports
import LogoSection from '../LogoSection';
import SearchSection from './SearchSection';
import ProfileSection from './ProfileSection';
import NotificationSection from './NotificationSection';
import CalenderSection from './CalenderSection';
import HistorySection from './HistorySection';
import HelpCenterSection from './HelpCenterSection';

// assets
import { IconMenu2 } from '@tabler/icons';
import { useSelector } from 'react-redux';
import { useState } from 'react';
import PermisssionViewValidationWrapper from 'Components/PermissionWrapper/PermissionViewValidationWrapper';
import { PermissionTypes } from 'Components/PermissionWrapper/constants';
import PermissionWrapper from 'Components/PermissionWrapper';

// ==============================|| MAIN NAVBAR / HEADER ||============================== //

const Header = ({ handleLeftDrawerToggle }) => {
    const theme = useTheme();
    const [toggleSidebar, setToggleSideBar] = useState(1);
    const authentication = useSelector((state) => state.authentication);
    let { hasSubscribed, companyValidated } = authentication;
    let showItem = false;
    if (hasSubscribed && companyValidated) {
        showItem = true;
    }

    const handleToggleSidebar = () => {
        handleLeftDrawerToggle();
        setToggleSideBar((prev) => !prev);
    };
    return (
        <>
            {/* logo & toggler button */}
            <Box
                sx={{
                    width: 228,
                    display: 'flex',
                    [theme.breakpoints.down('lg')]: {
                        width: 'auto'
                    }
                }}
            >
                <Stack direction="row" alignItems={'center'} sx={{ display: { xs: 'none', lg: 'flex' }, flexGrow: 1 }}>
                    <IconButton disableRipple sx={{ color: '#ffffff', padding: '0' }} onClick={handleToggleSidebar}>
                        <MenuRoundedIcon />
                    </IconButton>
                    <LogoSection />
                </Stack>
                {/* <ButtonBase sx={{ display: { lg: 'none' }, borderRadius: '12px', overflow: 'hidden' }}>
                    <Avatar
                        variant="rounded"
                        sx={{
                            ...theme.typography.commonAvatar,
                            ...theme.typography.mediumAvatar,
                            transition: 'all .2s ease-in-out',
                            background: theme.palette.white.light,
                            color: theme.palette.orange.light,
                            '& svg': {
                                stroke: theme.palette.orange.light
                            },
                            '&:hover': {
                                // background: theme.palette.primary.dark,
                                color: theme.palette.secondary.light
                            }
                        }}
                        onClick={handleLeftDrawerToggle}
                        color="inherit"
                    >
                        <IconMenu2 stroke={1.5} size="1.3rem" />
                    </Avatar>
                </ButtonBase> */}

                <IconButton disableRipple sx={{ color: '#ffffff', padding: '0', display: { lg: 'none' } }} onClick={handleLeftDrawerToggle}>
                    <MenuRoundedIcon />
                </IconButton>
            </Box>
            {/* header search */}
            {showItem && (
                <>
                    {/* <SearchSection /> */}
                    <Box sx={{ flexGrow: 1 }} />
                    <Box sx={{ flexGrow: 1 }} />

                    {/* notification & profile */}
                    {/* <HistorySection /> */}
                    <NotificationSection />
                    <PermisssionViewValidationWrapper pageName={PermissionTypes.calendar} isNotNavigate={true}>
                        <CalenderSection />
                    </PermisssionViewValidationWrapper>
                </>
            )}
            <Divider component="div" orientation="vertical" />
            {!showItem && (
                <>
                    <Box sx={{ flexGrow: 1 }} />
                    <Box sx={{ flexGrow: 1 }} />
                </>
            )}
            <HelpCenterSection />
            <ProfileSection />
        </>
    );
};

Header.propTypes = {
    handleLeftDrawerToggle: PropTypes.func
};

export default Header;
